/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getCorporategrpList: (params) => {
    return axios.get(API_ENDPOINTS.GET_CORPORATE_GRP, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getCorpGrpDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_CORPORATE_GRP_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addCorporategroup: (data) => {
    return axios.post(API_ENDPOINTS.ADD_GROUPS, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  updateCorporategrp: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_CORPORATE_GRP_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  deleteCorpgrp: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_CORPORATE_GRP_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  deletedriver: (data) => {
  return axios.delete(API_ENDPOINTS.DELETE_DRIVER, {
    headers: { isAuthRequired: true, "Content-Type": "application/json" },
    data
  });
  },
  getPassengerrequesthistory: (params) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_REQUEST_HISTORY + "/" + params.passenger_id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params
    });
  },
  getPassengerrequesthistorybyid: (id) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_REQUEST_HISTORY_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" }
    });
  },
  getPassengertriphistorybyid: (id) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_TRIP_HISTORY_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" }
    });
  },
  deletePassengerrequesthistorybyid: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_PASSENGER_REQUEST_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" }
    });
  },
};
